import styled from 'styled-components';

export const TicketTypeCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const Icon = styled.span`
  width: 20px;
  height: 20px;
  font-size: 20px;
`;
